import React, {useState} from "react";
import {Button, Card, Input, Modal, Spinner, Text} from "@ui-kitten/components";
import {View} from "react-native";
import {Bold} from "../shared/bold";
import {AsyncButtonWithSpinner} from "../shared/async-button-with-spinner";
import {ModalLayout} from "../shared/modal-layout";

export const ModalVerifyCode = ({emailSignVerifCode, email, visible}) => {
    const [verifyCode, setVerifyCode] = useState(false);

    if(!visible) return null
    return <ModalLayout title="Account Verification">
            <View style={{marginBottom: 15}}>
                <Text style={{fontSize: 20}}>We have sent an email to :</Text>
                <Bold>{email}</Bold>
            </View>

            <View style={{marginBottom: 15}}>
                <Text><Bold>Step 1</Bold>: Check your emails</Text>
            </View>

            <View style={{marginBottom: 15}}>
                <Text><Bold>Step 2</Bold>: Enter the code received by email : </Text>
                <View style={{marginTop: 15, alignItems: "center"}}>
                    <Input autoFocus={true} size="large" style={{width: 90}} value={verifyCode}
                           onChangeText={text => setVerifyCode(text)}
                           keyboardType="number-pad"/>

                    <AsyncButtonWithSpinner onPress={() => emailSignVerifCode(verifyCode, () => setVerifyCode(''))} onWhite={true}>Verify my account</AsyncButtonWithSpinner>
                </View>
            </View>
    </ModalLayout>
};